import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["containerWrapper", "logoContainer"];

  connect() {
    this.renderBanner();
    this.animateBanner();
  }

  renderBanner() {
    if (window.innerWidth > 1040) {
      this.containerWrapperTarget.innerHTML = `
            <div class="logo-container d-flex justify-content-between mb-5 mx-auto" data-art-qr-code--art-qr-code-target="logoContainer">
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-10.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-9.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-8.svg" alt="Main Img" class="main-logo-qr img-fluid displaced">
                <img src="/static/pages/art-qr-img/me-qr-7.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-1.svg" alt="Main Img" class="main-logo-qr img-fluid displaced">
                <img src="/static/pages/art-qr-img/me-qr.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-4.svg" alt="Main Img" class="main-logo-qr img-fluid displaced">
                <img src="/static/pages/art-qr-img/me-qr-2.svg" alt="Main Img" class="main-logo-qr img-fluid displaced">
                <img src="/static/pages/art-qr-img/me-qr-3.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-6.svg" alt="Main Img" class="main-logo-qr img-fluid displaced">
                <img src="/static/pages/art-qr-img/me-qr-5.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-12.svg" alt="Main Img" class="main-logo-qr img-fluid displaced">
                <img src="/static/pages/art-qr-img/me-qr-11.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-13.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            <div class="d-flex align-items-center flex-column logo-wrapper">
                <img src="/static/pages/art-qr-img/me-qr-14.svg" alt="Main Img" class="main-logo-qr img-fluid">
            </div>
            </div>
    `;
    }
  }

  animateBanner() {
    setTimeout(() => {
      this.logoContainerTarget.classList.add("animate");
    }, 800);


    let observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          this.logoContainerTarget.classList.add("animate");
          observer.disconnect();
        }
      });
    });
    observer.observe(this.logoContainerTarget);
  }
  gtagClick(e){
    const hasHref = e.currentTarget.href;
    e.preventDefault();
    const event = e.params.event;
    const lang = e.params.lang;
    gtag("event", event , {
      site_language: lang,
    });
    setTimeout(() => {
      window.location.href = hasHref;
    }, 150);
  }
}